<template>
  <div v-if="!isError">
    <div class="d-flex justify-content-center">
      <div class="spinner-border" role="status">
        <span class="sr-only">Loading...</span>
      </div>
      <h3 class="padding-left-15">Wczytywanie...</h3>
    </div>
  </div>
  <div v-else>
    <div class="row mt-4">
      <div class="col-4 offset-4">
        <b-card bg-variant="danger" text-variant="white" header="Wystąpił błąd" class="text-center">
          <b-card-text>
            <div class="row">
              <div class="col">
                <span v-if="error.message == 'Network Error'"
                  >Wystąpił błąd połączenia z serwerem. Spróbuj ponownie za chwilę<br />
                  Jeżeli problem cały czas występuje skontaktuj się z Administratorem systemu.
                </span>
                <span v-else>
                  Wystąpił nie przewidziany błąd. <br />
                  Jeżeli problem cały czas występuje skontaktuj się z Administratorem systemu.
                </span>
              </div>
            </div>
              <hr />
            
            <div class="row mt-6">
              <div class="col-3">Request URL:</div>
              <div class="col-9">{{ error?.config?.url }}</div>
            </div>
          </b-card-text>
        </b-card>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Loading',
  methods: {
    ShowErrorMessage(error) {
      this.isError = true;
      this.error = error;
    },
  },
  data() {
    return {
      isError: false,
      error: {},
    };
  },
};
</script>
<style>
.padding-left-15 {
  padding-left: 15px;
}
</style>
